import DownloadUploadStatusReportRequestModelBase from '../_generated/modelBases/download-upload-status-report-request-model-base';

export default class DownloadUploadStatusReportRequestModel extends DownloadUploadStatusReportRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
